import { EntidadeBase } from 'hay-core-react';
class PermissaoModel extends EntidadeBase {
  constructor() {
    super('permissao');
  }
}

export default new PermissaoModel();
